<template>
  <div>
    <!-- SFP Info Table -->
    <table class="table align-items-center mb-0">
      <thead>
        <tr>
          <th class="text-sm">Interface</th>
          <th class="text-sm">TX Power (dBM)</th>
          <th class="text-sm">RX Power (dBM)</th>
          <th class="text-sm">Bias (mA)</th>
          <th class="text-sm">Temperature (℃)</th>
          <th class="text-sm">Supply Voltage (V)</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="loading">
          <tr>
            <td colspan="6">
              <Skalaton />
            </td>
          </tr>
        </template>
        <template v-else-if="sfpInfo?.modules && sfpInfo.modules.length">
          <tr
            v-for="(module, index) in sfpInfo.modules"
            :key="index"
          >
            <td class="text-sm font-weight-bold">{{ getInterfaceWithDescription(module.Interface) }}</td>
            <td class="text-sm">{{ module['TX Power (dBM)'] || 'N/A' }}</td>
            <td class="text-sm">{{ module['RX Power (dBM)'] || 'N/A' }}</td>
            <td class="text-sm">{{ module['Bias (mA)'] || 'N/A' }}</td>
            <td class="text-sm">{{ module['Temperature (℃)'] || 'N/A' }}</td>
            <td class="text-sm">{{ module['Supply Voltage (V)'] || 'N/A' }}</td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td colspan="6" class="text-center">No SFP information available</td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import Skalaton from '@/components/Skalaton.vue';

export default {
  name: 'SFPInfoTable',
  components: {
    Skalaton
  },
  props: {
    sfpInfo: {
      type: Object,
      default: () => ({})
    },
    basicInfo: {
      type: Object,
      required: false,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    portDescriptions: {
      type: Object,
      required: false,
      default: () => null
    }
  },
  methods: {
    getInterfaceWithDescription(interfaceName) {
      if (!interfaceName) return 'N/A';
      
      if (!this.portDescriptions || !this.portDescriptions.ports || !Array.isArray(this.portDescriptions.ports)) {
        return interfaceName;
      }
      
      const port = this.portDescriptions.ports.find(p => p.Interface === interfaceName);
      
      if (port && port.description && port.description.trim() !== '') {
        return `${interfaceName} - ${port.description}`;
      }
      
      return interfaceName;
    }
  }
}
</script>

